// Seu serviço de eventos (pode ser um serviço separado)
import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/*
  criado  atualizacaoForcadaSubject--nome-do-component para reatualizar a lista pos acao,
   foi criado individual para evitar subcarga de memoria. Deve Ser criado para cada componente que necessitar reatualizar a lista apos acao.
  */
export class AtualizacaoForcadaService {
  private atualizacaoForcadaSubject = new Subject<void>();
  private atualizacaoForcadaCopartSubject = new Subject<void>();
  private atualizacaoForcadaContratoSubject = new Subject<void>();
  private atualizacaoForcadaElegibilidadeSubject = new Subject<void>();
  private atualizacaoForcadaTabelaPrecoSubject = new Subject<void>();
  private atualizacaoForcadaGrupoCarenciaSubject = new Subject<void>();
  private atualizacaoForcadaCoberturaAdicionalSubject = new Subject<void>();
  private atualizacaoForcadaDadosDeMovimentacaoSubject = new Subject<void>();
  private atualizacaoForcadaCoberturasEspeciaisSubject = new Subject<void>();
  private atualizacaoForcadaNotificacaoSubject = new Subject<void>();
  private atualizacaoForcadaEmpresaProdutoContratoSubject = new Subject<void>();
  private atualizacaoForcadaEmpresaProdutoContratoSubjectForm = new Subject<void>();
  private atualizacaoForcadaNavBarSubject = new Subject<void>();
  private atualizacaoForcadaTermosSubject = new Subject<void>();
  private atualizacaoForcadaReajusteSubject = new Subject<void>();
  private atualizacaoForcadaArquivosEObservacoesSubject = new Subject<void>();
  private atualizacaoForcadaDependenteElegiveisSubject = new Subject<void>();
  private atualizacaoForcadaCorretorasSubject = new Subject<void>();
  private atualizacaoForcadaVendedoresSubject = new Subject<void>();
  private atualizacaoForcadaCorretoraVendedoresSubject = new Subject<void>();
  private atualizacaoForcadaUsuarioSubject = new Subject<void>();
  private atualizacaoForcadaLeadSubject = new Subject<void>();
  private atualizacaoForcadaCrmTarefasSubject = new Subject<void>();
  private atualizacaoForcadaRedeCredenciadaSubject = new Subject<void>();
  private fecharModalFonte = new Subject<void>();
  private atualizacaoForcadaCotacaoSubject = new Subject<void>();
  private atualizacaoForcadaCrmSubject = new Subject<void>();
  private atualizacaoForcadaDSColaboradorSubject = new Subject<void>();
  private atualizacaoForcadaRetornoDSSubject = new Subject<void>();
  private atualizacaoForcadaRetornoDSProximaPerguntaSubject = new Subject<void>();
  private atualizacaoForcadaRetornoDSVoltarPerguntaSubject = new Subject<void>();
  private atualizacaoForcadaPropostaSubject = new Subject<void>();
  private atualizacaoForcadaGrupoPermissoesSubject = new Subject<void>();
  private atualizacaoForcadaOperadoraSubject = new Subject<void>();
  private atualizacaoForcadaDocumentosCorretorSubject = new Subject<void>();
  private atualizacaoForcadaProdutoSubject = new Subject<void>();
  private atualizacaoForcadaBeneficiarioSubject = new Subject<void>();
  private atualizacaoForcadaPropostaBeneficiarioColaboradorSubject = new Subject<void>();
  private atualizacaoForcadaCrmDepartamentoSubject = new Subject<void>();
  private atualizacaoForcadaCrmTipoAtendimentoSubject = new Subject<void>();
  private atualizacaoForcadaCrmAtendimentoSubject = new Subject<void>();
  private atualizacaoForcadaExportacaoLotesSubject = new Subject<void>();
  private atualizacaoForcadaCarenciaSubject = new Subject<void>();
  private atualizacaoForcadaEmpresaEntidadeSubject = new Subject<void>();
  private atualizacaoForcadaLayoutVidaSubject = new Subject<void>();

  atualizacaoForcadaLayoutVida$ = this.atualizacaoForcadaLayoutVidaSubject.asObservable();
  private atualizacaoForcadaMenuSubject = new Subject<void>();

  atualizacaoForcadaMenu$ = this.atualizacaoForcadaMenuSubject.asObservable();
  atualizacaoForcada$ = this.atualizacaoForcadaSubject.asObservable();
  atualizacaoForcadaCopart$ = this.atualizacaoForcadaCopartSubject.asObservable();
  atualizacaoForcadaContrato$ = this.atualizacaoForcadaContratoSubject.asObservable();
  atualizacaoForcadaElegibilidade$ = this.atualizacaoForcadaElegibilidadeSubject.asObservable();
  atualizacaoForcadaTabelaPrecoSubject$ = this.atualizacaoForcadaTabelaPrecoSubject.asObservable();
  atualizacaoForcadaGrupoCarenciaSubject$ = this.atualizacaoForcadaGrupoCarenciaSubject.asObservable();
  atualizacaoForcadaCoberturaAdicionalSubject$ = this.atualizacaoForcadaCoberturaAdicionalSubject.asObservable();
  atualizacaoForcadaDadosDeMovimentacaoSubject$ = this.atualizacaoForcadaDadosDeMovimentacaoSubject.asObservable();
  atualizacaoForcadaCoberturasEspeciaisSubject$ = this.atualizacaoForcadaCoberturasEspeciaisSubject.asObservable();
  atualizacaoForcadaNotificacaoSubject$ = this.atualizacaoForcadaNotificacaoSubject.asObservable();
  atualizacaoForcadaEmpresaProdutoContratoSubject$ =
    this.atualizacaoForcadaEmpresaProdutoContratoSubject.asObservable();
  atualizacaoForcadaEmpresaProdutoContratoSubjectForm$ =
    this.atualizacaoForcadaEmpresaProdutoContratoSubjectForm.asObservable();
  atualizacaoForcadaNavBarSubject$ = this.atualizacaoForcadaNavBarSubject.asObservable();
  atualizacaoForcadaTermosSubject$ = this.atualizacaoForcadaTermosSubject.asObservable();
  atualizacaoForcadaReajusteSubject$ = this.atualizacaoForcadaReajusteSubject.asObservable();
  atualizacaoArquivosEObservacoesSubject$ = this.atualizacaoForcadaArquivosEObservacoesSubject.asObservable();
  atualizacaoForcadaDependenteElegiveisSubject$ = this.atualizacaoForcadaDependenteElegiveisSubject.asObservable();
  atualizacaoForcadaCorretorasSubject$ = this.atualizacaoForcadaCorretorasSubject.asObservable();
  atualizacaoForcadaVendedoresSubject$ = this.atualizacaoForcadaVendedoresSubject.asObservable();
  atualizacaoForcadaCorretoraVendedoresSubject$ = this.atualizacaoForcadaCorretoraVendedoresSubject.asObservable();
  atualizacaoForcadaUsuarioSubject$ = this.atualizacaoForcadaUsuarioSubject.asObservable();
  atualizacaoForcadaLeadSubject$ = this.atualizacaoForcadaLeadSubject.asObservable();
  atualizacaoForcadaCrmTarefasSubject$ = this.atualizacaoForcadaCrmTarefasSubject.asObservable();
  atualizacaoForcadaRedeCredenciadaSubject$ = this.atualizacaoForcadaRedeCredenciadaSubject.asObservable();
  fecharModal$ = this.fecharModalFonte.asObservable();
  atualizacaoForcadaCotacaoSubject$ = this.atualizacaoForcadaCotacaoSubject.asObservable();
  atualizacaoForcadaCrmSubject$ = this.atualizacaoForcadaCrmSubject.asObservable();
  atualizacaoForcadaDSColaboradorSubject$ = this.atualizacaoForcadaDSColaboradorSubject.asObservable();
  atualizacaoForcadaRetornoDSSubject$ = this.atualizacaoForcadaRetornoDSSubject.asObservable();
  atualizacaoForcadaRetornoDSProximaPerguntaSubject$ =
    this.atualizacaoForcadaRetornoDSProximaPerguntaSubject.asObservable();
  atualizacaoForcadaRetornoDSVoltarPerguntaSubject$ =
    this.atualizacaoForcadaRetornoDSVoltarPerguntaSubject.asObservable();
  atualizacaoForcadaPropostaSubject$ = this.atualizacaoForcadaPropostaSubject.asObservable();
  atualizacaoForcadaGrupoPermissoesSubject$ = this.atualizacaoForcadaGrupoPermissoesSubject.asObservable();
  atualizacaoForcadaOperadoraSubject$ = this.atualizacaoForcadaOperadoraSubject.asObservable();
  atualizacaoForcadaDocumentosCorretorSubject$ = this.atualizacaoForcadaDocumentosCorretorSubject.asObservable();
  atualizacaoForcadaProdutoSubject$ = this.atualizacaoForcadaProdutoSubject.asObservable();
  atualizacaoForcadaBeneficiarioSubject$ = this.atualizacaoForcadaBeneficiarioSubject.asObservable();
  atualizacaoForcadaPropostaBeneficiarioColaboradorSubject$ =
    this.atualizacaoForcadaPropostaBeneficiarioColaboradorSubject.asObservable();
  atualizacaoForcadaCrmDepartamentoSubject$ = this.atualizacaoForcadaCrmDepartamentoSubject.asObservable();
  atualizacaoForcadaCrmTipoAtendimentoSubject$ = this.atualizacaoForcadaCrmTipoAtendimentoSubject.asObservable();
  atualizacaoForcadaCrmAtendimentoSubject$ = this.atualizacaoForcadaCrmAtendimentoSubject.asObservable();
  atualizacaoForcadaExportacaoLotesSubject$ = this.atualizacaoForcadaExportacaoLotesSubject.asObservable();
  atualizacaoForcadaCarenciaSubject$ = this.atualizacaoForcadaCarenciaSubject.asObservable();
  atualizacaoForcadaEmpresaEntidadeSubject$ = this.atualizacaoForcadaEmpresaEntidadeSubject.asObservable();

  emitirAtualizacaoForcadaCopart(): void {
    this.atualizacaoForcadaCopartSubject.next();
  }
  emitirAtualizacaoForcada(): void {
    this.atualizacaoForcadaSubject.next();
  }
  emitirAtualizacaoForcadaContrato(): void {
    this.atualizacaoForcadaContratoSubject.next();
  }
  emitirAtualizacaoForcadaTabelaPreco(): void {
    this.atualizacaoForcadaTabelaPrecoSubject.next();
  }
  emitirAtualizacaoForcadaGrupoCarencia(): void {
    this.atualizacaoForcadaGrupoCarenciaSubject.next();
  }
  emitirAtualizacaoForcadaElegibilidade(): void {
    this.atualizacaoForcadaElegibilidadeSubject.next();
  }
  emitirAtualizacaoForcadaCoberturaAdicional(): void {
    this.atualizacaoForcadaCoberturaAdicionalSubject.next();
  }
  emitirAtualizacaoForcadaDadosDeMovimentacao(): void {
    this.atualizacaoForcadaDadosDeMovimentacaoSubject.next();
  }
  emitirAtualizacaoForcadaCoberturasEspeciais(): void {
    this.atualizacaoForcadaCoberturasEspeciaisSubject.next();
  }
  emitirAtualizacaoForcadaNotificacao(): void {
    this.atualizacaoForcadaNotificacaoSubject.next();
  }

  //Resetar form ao clicar em nova empresa edicar
  emitirAtualizacaoForcadaEmpresaProdutoContrato(): void {
    this.atualizacaoForcadaEmpresaProdutoContratoSubject.next();
  }
  emitirAtualizacaoForcadaEmpresaProdutoContratoForm(): void {
    this.atualizacaoForcadaEmpresaProdutoContratoSubjectForm.next();
  }

  //atualizar nome de usuario no navbar
  emitirAtualizacaoForcadaNavBar(): void {
    this.atualizacaoForcadaNavBarSubject.next();
  }

  emitirAtualizacaoForcadaTermos(): void {
    this.atualizacaoForcadaTermosSubject.next();
  }

  emitirAtualizacaoForcadaReajuste(): void {
    this.atualizacaoForcadaReajusteSubject.next();
  }

  emitirAtualizacaoForcadaArquivosEObservacoes(): void {
    this.atualizacaoForcadaArquivosEObservacoesSubject.next();
  }
  atualizacaoForcadaEmpresaProdutoContrato(): void {
    this.atualizacaoForcadaEmpresaProdutoContratoSubject.next();
  }
  emitirAtualizacaoForcadaDependenteElegiveis(): void {
    this.atualizacaoForcadaDependenteElegiveisSubject.next();
  }
  emitirAtualizacaoForcadaCorretoras(): void {
    this.atualizacaoForcadaCorretorasSubject.next();
  }
  emitirAtualizacaoForcadaVendedores(): void {
    this.atualizacaoForcadaVendedoresSubject.next();
  }
  emitirAtualizacaoForcadaUsuario(): void {
    this.atualizacaoForcadaUsuarioSubject.next();
  }
  emitirAtualizacaoForcadaLeads(): void {
    this.atualizacaoForcadaLeadSubject.next();
  }
  emitirAtualizacaoForcadaCrmTarefas(): void {
    this.atualizacaoForcadaCrmTarefasSubject.next();
  }
  emitirAtualizacaoForcadaRedeCredenciada(): void {
    this.atualizacaoForcadaRedeCredenciadaSubject.next();
  }
  fecharModal() {
    this.fecharModalFonte.next();
  }
  emitirAtualizacaoForcadaCotacao(): void {
    this.atualizacaoForcadaCotacaoSubject.next();
  }
  emitirAtualizacaoForcadaCrm(): void {
    this.atualizacaoForcadaCrmSubject.next();
  }

  emitirAtualizacaoForcadaDSColaborador(): void {
    this.atualizacaoForcadaDSColaboradorSubject.next();
  }

  emitirAtualizacaoForcadaRetornoDS(): void {
    this.atualizacaoForcadaRetornoDSSubject.next();
  }
  emitirAtualizacaoForcadaRetornoDSProximaPergunta(): void {
    this.atualizacaoForcadaRetornoDSProximaPerguntaSubject.next();
  }
  emitirAtualizacaoForcadaRetornoDSVoltarPergunta(): void {
    this.atualizacaoForcadaRetornoDSVoltarPerguntaSubject.next();
  }
  emitirAtualizacaoForcadaProposta(): void {
    this.atualizacaoForcadaPropostaSubject.next();
  }
  emitirAtualizacaoForcadaGrupoPermissoes(): void {
    this.atualizacaoForcadaGrupoPermissoesSubject.next();
  }
  emitirAtualizacaoForcadaOperadora(): void {
    this.atualizacaoForcadaOperadoraSubject.next();
  }
  emitirAtualizacaoForcadaDocumentosCorretor(): void {
    this.atualizacaoForcadaDocumentosCorretorSubject.next();
  }
  emitirAtualizacaoForcadaProduto(): void {
    this.atualizacaoForcadaProdutoSubject.next();
  }
  emitirAtualizacaoForcadaBeneficiario(): void {
    this.atualizacaoForcadaBeneficiarioSubject.next();
  }
  emitirAtualizacaoForcadaPropostaColaboradorBeneficiario(): void {
    this.atualizacaoForcadaPropostaBeneficiarioColaboradorSubject.next();
  }
  emitirAtualizacaoForcadaCrmDepartamento(): void {
    this.atualizacaoForcadaCrmDepartamentoSubject.next();
  }
  emitirAtualizacaoForcadaCrmTipoAtendimento(): void {
    this.atualizacaoForcadaCrmTipoAtendimentoSubject.next();
  }
  emitirAtualizacaoForcadaCrmAtendimento(): void {
    this.atualizacaoForcadaCrmAtendimentoSubject.next();
  }

  emitirAtualizacaoForcadaExportacaoLotes(): void {
    this.atualizacaoForcadaExportacaoLotesSubject.next();
  }
  emitirAtualizacaoForcadaCarencia(): void {
    this.atualizacaoForcadaCarenciaSubject.next();
  }
  emitirAtualizacaoForcadaEmpresaEntidade(): void {
    this.atualizacaoForcadaEmpresaEntidadeSubject.next();
  }
  emitirAtualizacaoForcadaLayoutVida(): void {
    this.atualizacaoForcadaLayoutVidaSubject.next();
  }
  emitirAtualizacaoForcadaMenu(): void {
    this.atualizacaoForcadaMenuSubject.next();
  }
}
